import React, { Component, useEffect } from 'react'
import { Link } from "react-router-dom"
import {GetColor, getTCFs, getTCF, hasTCF} from "../config.js"
import "../../config/global.js"
import {
    Polygon,
    LayerGroup,
    Popup,
    useMap
} from 'react-leaflet'

export default class TCFLayer extends Component {
    constructor(area) {
        super()
        this.area = "ar"+area.area
        this.area_level = "area"+area.area
    }
    opacity = 0.9
    area = ""
    area_level = ""
    ag = ""
    gid_area = ""
    index = 1

    render() {
      this.ag = global[this.area].ag
      this.gid_area = global[this.area].gid_area
      //console.log(this.area_level, this.ag, this.gid_area, global.year, global.nat)
      //console.log(global.shapes[this.area_level][this.ag][this.gid_area], getTCFs(this.area))
      if(!(hasTCF(this.area) &&
        global.shapes[this.area_level][this.ag][this.gid_area] &&
        global.shapes[this.area_level][this.ag][this.gid_area].features
        //&& getTCFs(this.area).TCFs.length == global.shapes[this.area_level][this.ag][this.gid_area].features.length
      ))
        return (<LayerGroup/>)
      return (
        <LayerGroup>
        {
          (global.shapes[this.area_level][this.ag][this.gid_area].features.map((element, index) => {
            if(this.ag == 2){
              var name = element.properties.name_2
              var to = "/Neo4Tourism/Department"
            } else if(this.ag == 3){
              var name = element.properties.name_3
              var to = "/Neo4Tourism/District"
            } else if(this.ag == 4){
              var name = element.properties.name_4
              var to = "/Neo4Tourism/City"
            } else if(this.ag == 5){
              var name = element.properties.name_5
              var to = "/Neo4Tourism/Town"
            }
            var tcf = getTCF(this.area, name)
            return (
                  <Polygon key={name+" "+this.index++}
                    weight={1} color={'#bbbbbb'} fillColor={GetColor(tcf)} fillOpacity={this.opacity}
                    positions={element.geometry.coordinates}
                    onMouseOver={e => {setTimeout(function () {e.sourceTarget.openPopup();}, 700);}}>
                    <Popup autoPan={false}>
                            <div className="poly-popup">
                                <div><h4>{name}</h4>TCF : {tcf}</div>
                                <span><Link to={to}><span onClick={() => { global["ar"+(ar+1)].ag = global[this.area].ag+1; global["ar"+(ar+1)].name_area = element.properties["name_"+(ar+1)]; global["ar"+(ar+1)].center = [element.properties.centroidlat, element.properties.centroidlong] }}>Zoom</span></Link></span>
                                {" | "}
                                <span><Link to="/Neo4Tourism/Stats"><span onClick={() => { global.ar = global.ar; global.ag = global[this.area].ag; global.name_area = global[this.area].name_area; global.name_ag = name }}>Stats</span></Link></span>
                            </div>
                    </Popup>
                  </Polygon>
                )
          }))}
        </LayerGroup>)
    }
}
